import * as React from "react";

const Ac = ({ color }) => (
  <svg
    width="29"
    height="14"
    viewBox="0 0 29 14"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.9622 13.8777H1.9972C1.46652 13.8777 0.958657 13.6666 0.582042 13.2957C0.211133 12.919 0 12.4112 0 11.8805V1.9972C0 1.46652 0.211133 0.958657 0.582042 0.582042C0.958657 0.211133 1.46652 0 1.9972 0H26.9622C27.4929 0 28.0008 0.211133 28.3774 0.582042C28.754 0.958657 28.9594 1.46652 28.9594 1.9972V11.8805C28.9594 12.4112 28.7483 12.919 28.3774 13.2957C28.0008 13.6723 27.4929 13.8777 26.9622 13.8777ZM1.9972 0.998601C1.73471 0.998601 1.47793 1.10131 1.28962 1.28962C1.10131 1.47793 0.998601 1.72901 0.998601 1.9972V11.8805C0.998601 12.143 1.10131 12.3998 1.28962 12.5881C1.47793 12.7764 1.72901 12.8791 1.9972 12.8791H26.9622C27.2247 12.8791 27.4815 12.7764 27.6698 12.5881C27.8581 12.3998 27.9608 12.1487 27.9608 11.8805V1.9972C27.9608 1.73471 27.8581 1.47793 27.6698 1.28962C27.4815 1.10131 27.2304 0.998601 26.9622 0.998601H1.9972Z"
      fill={color}
    />
    <path
      d="M25.587 13.8772H3.37239C3.09849 13.8772 2.87024 13.6547 2.87024 13.3751V10.0597C2.87024 9.52902 3.08137 9.02116 3.45228 8.65025C3.8289 8.27363 4.33676 8.0625 4.86744 8.0625H24.0919C24.6226 8.0625 25.1305 8.27363 25.5071 8.65025C25.8837 9.02686 26.0891 9.53472 26.0891 10.0597V13.3751C26.0891 13.5063 26.0378 13.6318 25.9408 13.7288C25.8438 13.8259 25.7239 13.8772 25.587 13.8772ZM3.86884 12.8843H25.0905V10.0654C25.0905 9.80292 24.9878 9.54614 24.7995 9.35783C24.6112 9.16952 24.3601 9.06681 24.0919 9.06681H4.86744C4.60495 9.06681 4.34817 9.16952 4.15986 9.35783C3.97155 9.54614 3.86884 9.79721 3.86884 10.0654V12.8843Z"
      fill={color}
    />
    <path
      d="M25.587 11.476H3.37239C3.09849 11.476 2.87024 11.2534 2.87024 10.9738C2.87024 10.6942 3.09278 10.4717 3.37239 10.4717H25.5927C25.8666 10.4717 26.0949 10.6942 26.0949 10.9738C26.0949 11.2534 25.8666 11.476 25.587 11.476Z"
      fill={color}
    />
    <path
      d="M8.51937 4.72525H2.27669C2.00279 4.72525 1.77454 4.50271 1.77454 4.2231V2.44844C1.77454 2.17454 1.99708 1.94629 2.27669 1.94629H8.51937C8.65062 1.94629 8.77616 1.99765 8.87316 2.09465C8.96446 2.18595 9.02153 2.3172 9.02153 2.44844V4.2231C9.02153 4.35434 8.97017 4.47988 8.87316 4.57689C8.77616 4.6739 8.65062 4.72525 8.51937 4.72525ZM2.77314 3.72665H8.01722V2.94489H2.77314V3.72665Z"
      fill={color}
    />
    <path
      d="M25.125 3.33926C25.125 3.733 24.8054 4.04684 24.4174 4.04684C24.0294 4.04684 23.7098 3.72729 23.7098 3.33926C23.7098 2.95124 24.0237 2.62598 24.4174 2.62598C24.8112 2.62598 25.125 2.94553 25.125 3.33926Z"
      fill={color}
    />
    <path
      d="M27.196 3.33926C27.196 3.733 26.8765 4.04684 26.4885 4.04684C26.1004 4.04684 25.7809 3.72729 25.7809 3.33926C25.7809 2.95124 26.0947 2.62598 26.4885 2.62598C26.8822 2.62598 27.196 2.94553 27.196 3.33926Z"
      fill={color}
    />
    <path
      d="M23.0819 3.33926C23.0819 3.733 22.7624 4.04684 22.3743 4.04684C21.9806 4.04684 21.6667 3.72729 21.6667 3.33926C21.6667 2.95124 21.9806 2.62598 22.3743 2.62598C22.7624 2.62598 23.0819 2.94553 23.0819 3.33926Z"
      fill={color}
    />
  </svg>
);
export default Ac;
